






































import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import { HsabExpenseReimbursementResponse } from "@/shared/types";
import moment from "moment/moment";
import { formatCurrency } from "@/shared/currency.js";
import HsabWexClaimDenial from "@/employee/components/landing-pages/hsabank/expense/HsabWexClaimDenial.vue";

@Component({
  components: { HsabWexClaimDenial }
})
export default class HsabExpenseCardRowPaymentDetail extends Vue {
  formatCurrency = formatCurrency;

  @Prop()
  reimbursement: HsabExpenseReimbursementResponse;

  @Prop({ default: false })
  ExpenseHasAnyOverflow: boolean;

  isNullEmptyOrUndefined (val) {
    return val === undefined || val === null || val === "";
  }

  get hasReimbursement () {
    return !this.isNullEmptyOrUndefined(this.reimbursement);
  }

  get hasDenialReasons (): boolean {
    const hasDenials = this.reimbursement
        && this.reimbursement.denialReasons
        && this.reimbursement.denialReasons.length > 0;
    return hasDenials;
  }

  get isNotionalReimbursement () {
    return this.reimbursement
        && this.reimbursement.externalReimbursementId;
  }

  get isHsaReimbursement () {
    return this.reimbursement
        && this.reimbursement.planName === "Health Savings Account";
  }

  get paidAmountOrZero (): number {
    if (this.reimbursement && this.reimbursement.paidAmount) {
      return this.reimbursement.paidAmount;
    }
    return 0;
  }

  get approvedAmountOrZero (): number {
    if (this.reimbursement && this.reimbursement.approvedAmount) {
      return this.reimbursement.approvedAmount;
    }
    return 0;
  }

  get formattedFinalFilingDate () {
    if (this.reimbursement && this.reimbursement.planYearFinalFilingDate) {
      return moment(this.reimbursement.planYearFinalFilingDate).format("MMM DD, YYYY");
    }
    return "";
  }

  get formattedScheduledForReimbursementDate () {
    if (this.reimbursement && this.reimbursement.scheduledForReimbursementDate) {
      return moment(this.reimbursement.scheduledForReimbursementDate).format("MMM DD, YYYY");
    }
    return "";
  }

  get showScheduledReimbursementDate () {
    return this.reimbursement && !this.isNullEmptyOrUndefined(this.reimbursement.scheduledForReimbursementDate);
  }

  get showApprovedAmount () {
    return this.reimbursement && !this.isNullEmptyOrUndefined(this.reimbursement.approvedAmount);
  }

  get showPlanName () {
    return this.reimbursement && !this.isNullEmptyOrUndefined(this.reimbursement.planName);
  }

  get showPlanYearName () {
    return this.reimbursement && !this.isNullEmptyOrUndefined(this.reimbursement.planYearName);
  }

  get showPlanYearFinalFilingDate () {
    return this.reimbursement && !this.isNullEmptyOrUndefined(this.reimbursement.planYearFinalFilingDate);
  }

  get showPaidAmount () {
    return !this.isNullEmptyOrUndefined(this.paidAmountOrZero);
  }
}
